import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import { Icon } from '../../../Atoms/Icon';

const EditIcon = ({
  canEdit,
  slotName,
  onEditSimSlot,
  iconClass = '',
  ...props
}) => {
  return (
    <div>
      {canEdit && (
        <Button
          variant="link"
          onClick={() => onEditSimSlot(slotName)}
          {...props}
        >
          <Icon name="pencil" role="status" className={iconClass} />
        </Button>
      )}
      {!canEdit && (
        <Button variant="link" disabled {...props}>
          <Icon name="" role="status" className={iconClass} />
        </Button>
      )}
    </div>
  );
};

EditIcon.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  slotName: PropTypes.string.isRequired,
  onEditSimSlot: PropTypes.func.isRequired,
  iconClass: PropTypes.string,
};

export default EditIcon;
